export default __webpack_public_path__ + "static/media/phone-footer.b86b67e4.svg";